<script>
import axios from '@/utils/axios';

export default {
  inject: ['setLoading'],
  data() {
    return {
      email: '',
      errors: {},
      sent: false,
      marqueeRow1: [
        { id: 1, icon: '🪟', title: 'Track Every Order', subtitle: 'from quotation to dispatch' },
        { id: 2, icon: '📊', title: 'Smart Dashboard', subtitle: 'all metrics at a glance' },
        { id: 3, icon: '🏭', title: 'Inventory Control', subtitle: 'real-time stock tracking' },
        { id: 4, icon: '🪟', title: 'Track Every Order', subtitle: 'from quotation to dispatch' },
        { id: 5, icon: '📊', title: 'Smart Dashboard', subtitle: 'all metrics at a glance' },
        { id: 6, icon: '🏭', title: 'Inventory Control', subtitle: 'real-time stock tracking' },
      ],
      marqueeRow2: [
        { id: 1, icon: '🚪', title: 'Delivery Challans', subtitle: 'streamlined dispatch flow' },
        { id: 2, icon: '🔔', title: 'Never Miss a Follow-up', subtitle: 'automated reminders' },
        { id: 3, icon: '🔒', title: '100% Secure & Private', subtitle: 'your data is safe' },
        { id: 4, icon: '🚪', title: 'Delivery Challans', subtitle: 'streamlined dispatch flow' },
        { id: 5, icon: '🔔', title: 'Never Miss a Follow-up', subtitle: 'automated reminders' },
        { id: 6, icon: '🔒', title: '100% Secure & Private', subtitle: 'your data is safe' },
      ],
    };
  },
  mounted() {
    this.updateBodyClass();
  },
  watch: {
    $route() {
      this.updateBodyClass();
    },
  },
  methods: {
    updateBodyClass() {
      if (this.$route.path.includes("/forgot-password")) {
        document.body.classList.add("bg-white");
      } else {
        document.body.classList.remove("bg-white");
      }
    },
    async submitForm() {
      this.errors = {};
      if (!this.email || !this.email.trim()) {
        this.errors.email = ['Please enter your email address'];
        return;
      }
      this.setLoading(true);
      try {
        const response = await axios.post('/auth/forgot-password', {
          email: this.email.trim(),
        });
        this.sent = true;
        this.$swalToast(response.data.message || 'Password reset link sent to your email!', 'success');
      } catch (error) {
        if (error.response?.data?.errors) {
          this.errors = error.response.data.errors;
        } else {
          this.$swalToast(error.response?.data?.message || 'Failed to send reset link', 'error');
        }
      } finally {
        this.setLoading(false);
      }
    },
  },
};
</script>

<template>
<div class="container-fuild">
<div class="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
<div class="row">
<div class="col-lg-6">
  <div
    class="login-background position-relative d-none d-lg-flex align-items-center justify-content-center flex-wrap vh-100"
    style="background: linear-gradient(135deg, #0a1628 0%, #0d2b4e 40%, #1a3a5c 100%); overflow: hidden;"
  >
    <div class="position-absolute top-0 start-0 w-100 h-100" style="background-image:linear-gradient(rgba(255,255,255,0.02) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.02) 1px,transparent 1px);background-size:40px 40px;pointer-events:none;"></div>

    <div class="position-absolute" style="top:-80px;left:-80px;width:300px;height:300px;background:radial-gradient(circle,rgba(56,189,248,0.25) 0%,transparent 70%);pointer-events:none;"></div>
    <div class="position-absolute" style="bottom:-60px;right:-60px;width:250px;height:250px;background:radial-gradient(circle,rgba(14,165,233,0.2) 0%,transparent 70%);pointer-events:none;"></div>

    <div class="authentication-card w-90 position-relative" style="z-index:2;">

      <div class="mb-4">
        <img src="@/assets/img/logo-white.webp" alt="StayBright Logo" style="height:40px;width:auto;object-fit:contain;" />
      </div>

      <h1 class="fw-bold lh-sm mb-2" style="color:#fff;font-size:35px;">
        One platform to manage <br/>
        <span style="color:rgba(255,255,255,0.7);">your Windows, Doors</span><br/>
        <span style="color:#38bdf8;">& grow your business.</span>
      </h1>
      <p class="mb-4" style="color:#fff;font-size:16px;">
        The smarter way to manage leads, uPVC orders <br> & dispatch operations.
      </p>

      <div class="marquee-wrapper mb-3" style="overflow:hidden;">
        <div class="marquee-track">
          <div v-for="card in marqueeRow1" :key="'a'+card.id" class="marquee-card">
            <span style="font-size:16px;">{{ card.icon }}</span>
            <div>
              <div class="fw-semibold text-white" style="font-size:14px;">{{ card.title }}</div>
              <div style="color:rgba(255,255,255,0.5);font-size:12px;">{{ card.subtitle }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="marquee-wrapper mb-4" style="overflow:hidden;">
        <div class="marquee-track marquee-reverse">
          <div v-for="card in marqueeRow2" :key="'b'+card.id" class="marquee-card" style="background:rgba(56,189,248,0.12);border-color:rgba(56,189,248,0.25);">
            <span style="font-size:16px;">{{ card.icon }}</span>
            <div>
              <div class="fw-semibold text-white" style="font-size:14px;">{{ card.title }}</div>
              <div style="color:rgba(255,255,255,0.5);font-size:12px;">{{ card.subtitle }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-between pt-3 border-top" style="border-color:rgba(255,255,255,0.08) !important;">
        <div>
          <div class="fw-bold text-white" style="font-size:25px;">15+</div>
          <div style="color:rgba(255,255,255,0.4);font-size:16px;">Years Experience</div>
        </div>
        <div>
          <div class="fw-bold text-white" style="font-size:25px;">1M+</div>
          <div style="color:rgba(255,255,255,0.4);font-size:16px;">Sq.Ft Installed</div>
        </div>
        <div>
          <div class="fw-bold text-white" style="font-size:25px;">100%</div>
          <div style="color:rgba(255,255,255,0.4);font-size:16px;">German Technology</div>
        </div>
      </div>

    </div>
  </div>
</div>
<div class="col-lg-6 col-md-12 col-sm-12">
<div class="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap">
<div class="col-md-7 mx-auto p-4">
<form @submit.prevent="submitForm">
  <div>
    <div class="mx-auto mb-5 text-center">
      <img src="@/assets/img/logo.webp" class="img-fluid" alt="Logo" width="250" />
    </div>
    <div class="">
      <div class="text-center mb-4">
        <h2 class="aa-form-title mb-2">Forgot Password?</h2>
        <p class="aa-form-subtitle mb-0">Enter your email and we'll send you a link to reset your password.</p>
      </div>

      <div class="mb-3">
        <label class="form-label aa-label">Email Address</label>
        <div class="aa-input-group">
          <span class="aa-input-icon-left">
            <i class="ti ti-mail"></i>
          </span>
          <input type="text" v-model="email" class="form-control aa-input" placeholder="you@company.com" />
        </div>
        <div v-if="errors.email" class="text-danger small mt-1">{{ errors.email[0] }}</div>
      </div>

      <div class="mb-3">
        <button type="submit" class="btn aa-btn-signin w-100">
          Send Reset Link
          <i class="ti ti-arrow-right ms-1"></i>
        </button>
      </div>

      <div class="text-center">
        <h6 class="fw-normal text-dark mb-0">
          Return to
          <router-link to="login" class="hover-a aa-link">Login In</router-link>
        </h6>
      </div>
    </div>
    <div class="mt-5 text-center">
      <p class="mb-0 aa-copyright">
        Copyright &copy; 2026 -  Stay Bright Windows
      </p>
    </div>
  </div>
</form>
</div>
</div>
</div>
</div>
</div>
</div>
</template>

<style scoped>
.aa-form-title { font-size: 1.6rem; font-weight: 700; color: #1e1b4b; }
.aa-form-subtitle { color: #6b7280; font-size: 0.9rem; }
.aa-label { font-size: 0.85rem; font-weight: 600; color: #374151; margin-bottom: 6px; }
.aa-input-group { position: relative; display: flex; align-items: center; }
.aa-input-icon-left { position: absolute; left: 14px; color: #9ca3af; font-size: 1.1rem; z-index: 2; display: flex; align-items: center; }
.aa-input { padding-left: 42px !important; height: 46px; border: 1.5px solid #e5e7eb; border-radius: 10px; font-size: 0.9rem; color: #1f2937; background: #f9fafb; transition: border-color 0.2s, background-color 0.2s, box-shadow 0.2s; }
.aa-input::placeholder { color: #b0b7c3; }
.aa-input:focus { border-color: #0ea5e9; background: #ffffff; box-shadow: 0 0 0 3px rgba(14,165,233,0.1); }
.aa-btn-signin { background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%); border: none; color: #ffffff; height: 46px; border-radius: 10px; font-size: 0.95rem; font-weight: 600; letter-spacing: 0.2px; transition: transform 0.15s, box-shadow 0.2s, background 0.2s; }
.aa-btn-signin:hover { background: linear-gradient(135deg, #0284c7 0%, #0369a1 100%); color: #ffffff; box-shadow: 0 4px 14px rgba(14,165,233,0.35); transform: translateY(-1px); }
.aa-link { color: #0ea5e9; font-weight: 600; text-decoration: none; }
.aa-link:hover { color: #0284c7; }
.aa-copyright { font-size: 0.8rem; color: #9ca3af; }
</style>